export default function Benefits() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const benefits = [
    {
      title: 'Relatório Detalhado de Economia Potencial',
      description:
        'Projeção personalizada de quanto sua empresa pode economizar nos próximos 12, 24 e 36 meses',
    },
    {
      title: 'Análise Técnica de Elegibilidade',
      description: 'Verificação completa dos requisitos técnicos e documentais da sua instalação',
    },
    {
      title: 'Mapeamento de Fornecedores Ideais',
      description:
        'Identificação dos geradores e comercializadores mais adequados ao seu perfil de consumo',
    },
    {
      title: 'Simulação de Contratos',
      description: 'Modelos de contratos otimizados para sua realidade empresarial',
    },
    {
      title: 'Cronograma de Migração',
      description: 'Planejamento detalhado de todas as etapas necessárias, com prazos realistas',
    },
    {
      title: 'Consulta Estratégica',
      description:
        '30 minutos com um de nossos especialistas para esclarecer todas as suas dúvidas',
    },
  ];

  const testimonials = [
    {
      quote:
        'Reduzimos nossa conta de energia em 27% logo no primeiro mês. O processo foi muito mais simples do que imaginávamos e o retorno foi imediato. Não precisamos investir nada e a economia já impactou positivamente nosso fluxo de caixa.',
      author: 'Carlos Mendes',
      position: 'Diretor Financeiro - Indústria Têxtil',
    },
    {
      quote:
        'Estávamos céticos no início, achando que seria um processo burocrático e complicado. Mas a equipe nos guiou em cada etapa e hoje economizamos cerca de R$15.000 mensais. Foi a melhor decisão que tomamos para reduzir custos operacionais.',
      author: 'Ana Oliveira',
      position: 'Proprietária - Rede de Supermercados',
    },
    {
      quote:
        'Como gestor de um hospital, qualquer economia é crucial para reinvestirmos em equipamentos e melhorias. A migração para o Mercado Livre nos permitiu economizar 22% nos custos de energia, sem nenhuma interrupção nos serviços essenciais.',
      author: 'Dr. Roberto Santos',
      position: 'Administrador - Hospital São Lucas',
    },
  ];

  return (
    <section id="benefits" className="py-12 md:py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-4xl font-bold text-[#003366] mb-6 md:mb-8 text-center leading-tight">
          TUDO O QUE VOCÊ RECEBE COM NOSSA ANÁLISE DE VIABILIDADE GRATUITA...
        </h2>
        <p className="text-center text-base md:text-lg text-[#003366] font-semibold mb-8 md:mb-12 max-w-4xl mx-auto">
          Um diagnóstico completo que vale R$3.500, sem nenhum custo ou compromisso
        </p>

        <div className="mb-8 md:mb-12">
          <p className="text-center text-base md:text-lg mb-6 md:mb-8">
            Ao solicitar sua análise gratuita, você receberá:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white p-5 md:p-6 rounded-lg shadow-md border-l-4 border-green-500 flex flex-col h-full hover:shadow-xl transition-all duration-300"
              >
                <div className="flex items-start mb-3 md:mb-4">
                  <i className="ri-check-line text-green-500 text-xl md:text-2xl mr-2 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-base md:text-lg font-bold text-gray-800 mb-2">{benefit.title}</h3>
                <p className="text-sm md:text-base text-gray-700">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white p-5 md:p-8 rounded-lg shadow-md max-w-4xl mx-auto text-center mb-10 md:mb-16">
          <p className="text-sm md:text-base text-gray-800 font-bold">
            Tudo isso sem nenhum custo, compromisso ou obrigação de contratação.
          </p>
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-[#003366] mb-6 md:mb-8 text-center leading-tight">
          O QUE EMPRESÁRIOS COMO VOCÊ ESTÃO DIZENDO DEPOIS DE MIGRAREM PARA O MERCADO LIVRE DE
          ENERGIA...
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8 mt-8 md:mt-12 mb-8 md:mb-12">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-5 md:p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 flex flex-col h-full"
            >
              <div className="text-[#4A90E2] mb-3 md:mb-4 w-8 h-8 flex items-center justify-center">
                <i className="ri-double-quotes-l text-2xl md:text-3xl"></i>
              </div>
              <p className="text-sm md:text-base text-gray-700 flex-grow mb-4 md:mb-6 italic">{testimonial.quote}</p>
              <div>
                <p className="font-semibold text-[#003366] text-sm md:text-base">{testimonial.author}</p>
                <p className="text-xs md:text-sm text-gray-600">{testimonial.position}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={scrollToContact}
            className="bg-[#003366] hover:bg-[#004080] text-white font-bold py-3 md:py-4 px-6 md:px-8 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg hover:scale-105 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            QUERO MINHA ANÁLISE GRATUITA
          </button>
        </div>
      </div>
    </section>
  );
}
